import request from '@/utils/request' // 引入封装的request.js文件
import qs from 'qs'
// 暴露出我们的接口请求,export导出
// 登录接口
export function Login(data) {
  return request({
    url: '/bolan/token/',
    method: 'post',
    data: data,
  })
}
// 注册接口
export function Register(data) {
  return request({
    url: '/bolan/user/',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}

// 获取验证接口
export function Code(query) {
  return request({
    url: '/bolan/user/',
    method: 'get',
    params: query
  })
}

// 申请试用
export function Apply(data) {
  return request({
    url: '/bolan/apply/',
    method: 'post',
    data: data,
  })
}

// 权限
export function BolanRole(query) {
  return request({
    url: '/bolan/permission/',
    method: 'get',
    params: query
  })
}

// 添加记录
export function History(query) {
  return request({
    url: '/bolan/browse/',
    method: 'get',
    params: query
  })
}

// 浏览列表
export function hisList(query) {
  return request({
    url: '/bolan/record/',
    method: 'get',
    params: query
  })
}

export function myProduct(query) {
  return request({
    url: '/bolan/myproduct/',
    method: 'get',
    params: query
  })
}

// 基本信息
export function basics(data) {
  return request({
    url: '/bolan/basics/',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}

// 修改密码
export function upPwd(data) {
  return request({
    url: '/bolan/amend/',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}


// 设备列表
export function ipList(query) {
  return request({
    url: '/bolan/api1/index/userdevs/',
    method: 'get',
    params: query
  })
}

// 申请删除
export function ipDel(data) {
  return request({
    headers:{
      'Content-Type': 'multipart/form-data'
},
    url: '/bolan/api1/index/userdevs/',
    method: 'post',
    data: data,
  })
}




// WEBPACK FOOTER //
// ./src/api/user.js